import React from "react";
import "./index.less";
import { useReducer, useState, useEffect } from "react";
import { Table, Button, Input, message, DatePicker, Pagination } from "antd";
import { crawlBehance, behanceList } from "../../api";
const initState = {
  value4: "",
  value5: "",
  value6: "",
  value7: null,
};


const reducer = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case "setData":
      return {
        ...state,
        ...action.data,
      };
  }
};
const recommendStatus = ['进行中', '成功', '失败'];
function CaseBehanceCrawling() {
  const [state, dispatch] = useReducer(reducer, initState);
  const [listLoading, setListLoading] = useState(false)
  const [tableList, setTableList] = useState()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [total, setTotal] = useState(20)
  useEffect(() => {
    getBehanceList(page)
  }, [])
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      width: '4%',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      width: '20%'
    },
    {
      title: '订阅号',
      dataIndex: 'subscriberName',
      width: '10%',
      render: (v, r) => {
        return (
          <span>{r.subscriberName ? r.subscriberName : '-'}</span>
        )
      }
    },
    {
      title: '对应分类',
      dataIndex: 'classify',
      width: '10%',
      render: (v, r) => {
        return (
          <span>{r.firstClassifyName}-{r.secondClassifyName}</span>
        )
      }
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      width: '12%',
    },
    {
      title: '爬取时间',
      dataIndex: 'createTime',
      width: '12%',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: '12%',
      render: (v) => {
        return (
          <span>{recommendStatus[v]}</span>
        )
      }
    },
  ]
  const onChange = (e) => {
    const value = e.target.value;
    const id = "value" + e.target.id;
    dispatch({
      type: "setData",
      data: {
        [id]: value,
      },
    });
  };
  const onOk = (e) => {
    console.log(e);
    dispatch({
      type: "setData",
      data: {
        value7: e,
      }
    })
    // console.log(e.format("YYYY-MM-DD HH:mm:ss"));
  }
  const submit = async (type) => {
    if (state.value4.trim() === "" || state.value7 === null) {
      return message.error("发布时间和url不能为空");
    }
    const data = {
      url: state.value4.trim(),
      subscribeName: state.value6.trim(),
      classifyName: state.value5.trim(),
      publishTime: state.value7.format("YYYY-MM-DD HH:mm:ss"),
    };
    // console.log(data);
    const result = await crawlBehance(data);
    if (result?.error?.errorCode === "0") {
      message.success("开始爬取");
      setPage(1);
      getBehanceList(page);
    } else {
      setPage(1);
      getBehanceList(page);
      message.error(result?.error?.errorMsg);
    }
  };
  // 获取table数据
  const getBehanceList = (page) => {
    setPage(page)
    setListLoading(true)
    behanceList(page, pageSize, 0)
      .then((res) => {
        if (res?.error?.errorCode == 0) {
          setTableList(res?.data.contents)
          setTotal(res?.data.total)
        }
      })
      .finally(() => {
        setListLoading(false)
      })
  }
  return (
    <div className="caseBehanceCrawling">
      {/* <Button className="caseCoverTitle">人工爬取behance需求</Button> */}
      <div className="topSubmit">
        <div>
          <div className="caseCoverItem">
            <span>输入URL</span>
            <Input id="4" onChange={onChange} />
          </div>
          <div className="caseCoverItem">
            <span>对应分类</span>
            <Input id="5" onChange={onChange} />
          </div>
        </div>
        <div>
          <div className="caseCoverItem">
            <span>订阅号</span>
            <Input id="6" onChange={onChange} />
          </div>
          <div className="caseCoverItem">
            <span>发布时间修改</span>
            <DatePicker id="7" format="YYYY-MM-DD HH:mm" onChange={onOk} showTime value={state.value7} />
          </div>
        </div>
        <Button onClick={() => submit(1)} className="caseCoverButton">
          提交
        </Button>
      </div>

      <div className="bottomTable">
        <Table
          loading={listLoading}
          columns={columns}
          dataSource={tableList}
          pagination={
            {
              total: total,
              current: page,
              onChange(page) {
                console.log(page)
                getBehanceList(page)
              },
              pageSize: pageSize
            }
          }
        />
      </div>
    </div>
  )
}

export default CaseBehanceCrawling;